var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.makeDelete}},[_vm._v(" "+_vm._s(_vm.$t('myCertificates.toolbar.delete'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }